/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunRequest>): WellArchitectedFrameworkAssessmentRunRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunRequest(), model);
        WellArchitectedFrameworkAssessmentRunRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunRequest>): WellArchitectedFrameworkAssessmentRunRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunRequest.newInstance(<WellArchitectedFrameworkAssessmentRunRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_definition_ids) {
            for (let val of this.assessment_definition_ids) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    assessment_definition_ids: Array<models.RecordIdentity>;

}
